<template>
  <div class="dashboard reviews business" :data-management-sentiment="filters.tone">
    <div class="navbar">
      <div class="left">
        <div class="title">
          <div class="wrap">
            <h4>Где клиенты сталкиваются с проблемами чаще всего</h4>
            <div class="sub-title">{{ project.name }} · отзывы клиентов по шагам клиентского пути и темам жалоб</div>
          </div>
        </div>

        <div class="end-area">
        </div>
      </div>
      <TopBlock :no-progress="true"></TopBlock>
    </div>
    <button class="btn btn-outline-secondary show-filters" @click="openFilter=!openFilter">
      <i class="bi bi-filter"></i>
      <template v-if="openFilter">Скрыть</template>
      <template v-else>Показать</template>
      фильтры
    </button>
    <div :class="'filters'+(openFilter?' open':'')">
      <MultiSelect v-if="company.products"
                   v-model="filters.product"
                   :options="company.products"
                   :multi="false"
                   :only_value="false"
                   name="Продукт"></MultiSelect>
      <!--      <MultiSelect v-if="company.cities"-->
      <!--                   v-model="filters.city"-->
      <!--                   :options="company.cities"-->
      <!--                   :multi="false"-->
      <!--                   :only_value="false"-->
      <!--                   name="Город"></MultiSelect>-->
      <MultiSelect
          v-model="filters.tone"
          :options="Object.keys(palettes).map(x=>{return {id: x, name: palettes[x].title}})"
          :multi="false"
          :only_value="true"
          :searchOn="false"
          :required="true"
          name="Тональность"></MultiSelect>


      <div class="filter-info">
        <button
  :class="'btn btn-success btn-primary' + (reportLoaded ? ' loaded' : '')"
  :disabled="reportLoaded"
  @click="loadHtml"
>
  <i v-if="!reportLoaded" class="bi bi-box-arrow-down"></i>
  <span v-else class="spinner"></span>
  <span>{{ reportLoaded ? 'Загрузка...' : 'Выгрузить' }}</span>
</button>
        <span class="period-info">

          <span class="line">Анализируемый период: <span class="date">{{ $moment(date_from).format("DD.MM.YYYY") }}-{{
              $moment(date_to).format("DD.MM.YYYY")
            }}</span></span>
          <span class="line">Период для сравнения: <span class="date">{{
              $compare_period(date_from, date_to)
            }}</span></span>
        </span>
        <b class="mono">{{ $pluralise(params.cur || 0, ["отзыв", "отзыва", "отзывов"]) }}</b> в выборке
      </div>

    </div>

    <div class="main">
      <AiSummary v-if="company.management_insights" :period="company.period"
                 :insights="company.management_insights"
                 :goToReview="goToReview"
      ></AiSummary>
      <div class="section-head">
        <div class="section-title-row">
          <h2 class="section-title">Карта проблем клиентского опыта</h2>
          <button class="help-btn help-button" ref="triggerButton"
                  @click="handlePopoverToggle" id="help-btn" aria-label="Как читать дашборд">?
          </button>
        </div>

        <p class="section-note">
          Число — это объём отзывов в выборке. Цвет — уровень объёма среди ячеек текущей карты: красный для негативных,
          зелёный для позитивных, синий для всех отзывов.
          Изменение — разница объёма с прошлым периодом такой же длины. Клик по ячейке, теме или шагу открывает
          подробности.
        </p>
        <CustomPopover
            ref="popover"
            :offset-x="10"
            :offset-y="10"
            popover-class="my-custom-popover"
        >

          <div class="help-popover--visible" id="help-popover">
            <h3>Как читать дашборд</h3>
            <p><b>Колонка</b> — это шаг клиентского пути:
              <template v-for="step in company.steps">
                <template v-if="!step.no_step">«{{ step.ui_label }}»,</template>
                <template v-else>. Если шаг определить не удаётся, отзыв попадает в колонку «{{
                    step.ui_label
                  }}».
                </template>
              </template>
            </p>
            <p><b>Строка</b> — это тема жалобы:
              {{ company.groups_l1?.flatMap(group => group.topics).map(topic => `«${topic.ui_label}»`).join(', ') }}.
            </p>
            <p><b>Характеристика</b> уточняет тему. Например, не просто
              «{{ company.groups_l1 ? company.groups_l1[0].topics[0].ui_label : '' }}», а
              {{
                company.groups_l1 ? company.groups_l1[0].topics[0].topics_l2.slice(-2).map(topic => `«${topic.name.charAt(0).toUpperCase() + topic.name.slice(1)}»`).join(' или ') : ''
              }}.
              Если отзыв говорит только о теме в целом, характеристика может быть не указана.</p>
            <p class="help-popover__spaced"><b>Изменение</b> — разница объёма отзывов с прошлым периодом такой же длины.
            </p>
            <div class="help-popover__count-rule">Правило подсчёта. Если в одном отзыве несколько проблем, этот же отзыв
              учитывается в нескольких строках.
            </div>
          </div>
        </CustomPopover>

      </div>
      <div :class="'hm-shell' + (load?' loading':'')" id="hm-shell" style="display: grid;" v-if="reviews.length">
        <div class="hm-corner sticky-top">
          <div class="legend">
            <div class="legend__title">{{ palettes[filters.tone].legendTitle }}</div>
            <div class="legend__scale-row" id="legend-scale">
              <div class="legend__scale-step" v-for="stage in palettes[filters.tone].buckets"
                   :style="{background: stage.background}"></div>
              <div class="legend__scale-step" :style="{background: palettes[filters.tone].top}"></div>
            </div>
            <div class="legend__scale-labels">
              <span>меньше</span><span></span><span></span><span></span><span>больше</span></div>
            <div class="legend__low">
              <span class="legend__low-mark"></span>
              <span>1 отзыв — без цвета</span>
            </div>
          </div>
          <div class="topic-axis-head">
            <div class="topic-axis-head__title">Темы</div>
          </div>
        </div>
        <div :style="`grid-template-columns: repeat(${table.steps.length}, minmax(150px, 1fr));`"
             class="hm-top-axis sticky-top" id="hm-top-axis">
          <template v-for="step in table.steps">
            <div :class="`cjm-card cjm-card`+(!step.stats.total?'--empty':'')"
                 :data-step="step.step.slug"
                 @click="step.stats.total?openModal(step.step, null, step.stats):''"
            >
              <div class="cjm-card__track">
                <div class="cjm-card__dot">{{ step.step.no_step ? '' : '0' + step.step.order }}</div>
              </div>
              <div class="cjm-card__content">
                <div class="cjm-card__name" v-tooltip="step.step.ui_description||step.step.description">
                  {{ step.step.ui_label }}
                </div>
                <div class="bottom">
                  <div class="cjm-card__nums">
                    <span class="cjm-card__total">{{ step.stats.total }}</span>
                    <span v-if="step.stats.total"
                          v-tooltip="`Предыдущее значение ${step.stats.prev} за период ${$compare_period(date_from, date_to)}`"
                          :class="'cjm-card__delta'+(step.stats.deltaPct>0?'--up':step.stats.deltaPct<0?'--down':'')">{{
                        fmtDelta(step.stats.deltaPct)
                      }}</span>
                  </div>
                  <div class="cjm-card__bar" v-if="step.stats.total">

                    <div class="cjm-card__bar-fill"
                         :style="{width: (table.total.steps > 0 ? (step.stats.total / table.total.steps) * 100 : 0)+'%'}"></div>
                  </div>

                  <div class="cjm-card__no-data" v-else>нет
                    данных
                  </div>
                </div>

              </div>
            </div>
          </template>

        </div>
        <div class="hm-left-axis" id="hm-left-axis">
          <template v-for="(group, g_index) in table.groups">
            <div class="topic-group-label topic-group-label--first"
                 :style="{'grid-row': 'span '+group.topics.length, '--group-color': group.color}">
              {{ group.label }}
            </div>
            <!--            <div v-for="(topic, t_index) in group.topics" class="num">-->
            <!--                            {{getGlobalIndex(g_index, t_index)}}-->
            <!--            </div>-->

            <div v-for="(topic, t_index) in group.topics"
                 :class="'theme-card' + (topic.topic.no_topic?' theme-card--empty theme-card--other':'')"
                 :data-topic-l1="topic.topic.slug"
                 :style="{'--theme-color': group.color}"
                 v-tooltip="topic.topic.ui_description"
                 @click="topic.stats.total?openModal(null, topic.topic, topic.stats):''"
            >
              <div class="theme-card__number" :style="{color: group.color}">
                {{ getGlobalIndex(g_index, t_index) }}
              </div>
              <div class="theme-card__name"> {{ topic.topic.ui_label }}</div>
              <div class="theme-card__metrics">
                <div class="theme-card__total">{{ topic.stats.total }}</div>
                <div v-if="topic.stats.total"
                     v-tooltip="`Предыдущее значение ${topic.stats.prev} за период ${$compare_period(date_from, date_to)}`"
                     :class="'theme-card__delta theme-card__delta'+(topic.stats.deltaPct>0?'--up':topic.stats.deltaPct<0?'--down':'')">
                  {{ fmtDelta(topic.stats.deltaPct) }}
                </div>
                <div v-else class="theme-card__delta " v-tooltip="`Нет данных`"><i class="bi bi-dash-lg"></i></div>
              </div>
            </div>
          </template>

        </div>
        <div class="hm-body" :style="`grid-template-columns: repeat(${table.steps.length}, minmax(150px, 1fr));`"
             id="hm-body">
          <div class="hm-group-row"></div>
          <template v-for="(cell, index) in table.cells">
            <HmCell :cell="cell"
                    :index="index"
                    :openModal="openModal"
                    :fmtDelta="fmtDelta"
                    :palettes="palettes"
                    :period="$compare_period(date_from, date_to)"
                    :filters="filters"
                    :heatmapColorLevels="heatmapColorLevels"
            ></HmCell>
          </template>

        </div>
      </div>

      <div :class="'empty-state' + (load?' loading':'')" id="empty-state" v-else>
        <span>
        <b>По этим фильтрам отзывов нет.</b> Расширьте период или снимите фильтр по продукту, городу или тональности.
          </span>
      </div>


      <div class="skeleton-note" id="quality-note">
        <b>Данные и качество.</b> Темы и характеристики определяет алгоритм автоматической классификации отзывов.
        Возможны ошибки разметки.
        Анализируемый период: {{ $moment(date_from).format("DD.MM.YYYY") }}-{{ $moment(date_to).format("DD.MM.YYYY") }}.
        Период для сравнения: {{ $compare_period(date_from, date_to) }}.
      </div>
    </div>
    <div class="tooltip" id="tooltip"></div>

    <modal modal_id="detail_info">
      <template v-slot:header>
        <div class="modal__head-main">
          <div class="modal__crumbs" id="modal-crumbs">
            <span v-if="modal.step">Шаг</span>
            <em v-if="modal.step && modal.topic">›</em>
            <span v-if="modal.topic">Тема</span>
          </div>
          <div class="modal__title" id="modal-title">
            <span class="modal__title-dot" :style="{background: modal.topic?.color}"></span>
            <span>{{ modal.step?.label }} <span
                v-if="modal.step && modal.topic">×</span> {{ modal.topic?.label }}</span>
          </div>
        </div>
        <div class="modal__head-stats" v-if="modal.stats">
          <div class="modal__head-stat">
            <div class="modal__head-stat-label">Анализируемый период: {{
                $moment(date_from).format("DD.MM.YYYY")
              }}-{{ $moment(date_to).format("DD.MM.YYYY") }}
            </div>
            <div class="modal__head-stat-label">Период для сравнения: {{ $compare_period(date_from, date_to) }}</div>
          </div>
          <div class="modal__head-stat">
            <div class="modal__head-stat-label">Отзывов</div>
            <div class="modal__head-stat-val" id="modal-total">{{ modal.stats?.total }}</div>
          </div>

          <div class="modal__head-stat">
            <div class="modal__head-stat-label">Изменение</div>
            <div v-tooltip="`Предыдущее значение ${modal.stats.prev} за период ${$compare_period(date_from, date_to)}`"
                 :class="'modal__head-stat-val' + (modal.stats.deltaPct > 1?' modal__head-stat-val--neg':'')"
                 id="modal-delta">{{ fmtDelta(modal.stats.deltaPct) }}
            </div>
          </div>
        </div>
      </template>
      <template v-slot:body>
        <div class="modal__context" id="modal-context">
          <div class="modal__context-title">Какие отзывы попали в эту выборку</div>
          <p><b>В этой выборке</b> — отзывы, где проблема относится к
            <template v-if="modal.step">шагу «{{ modal.step.ui_label }}»</template>
            <template v-if="modal.step && modal.topic"> и</template>
            <template v-if="modal.topic"> теме «{{ modal.topic.ui_label }}».</template>
          </p>
          <p v-if="modal.step"><b>Что входит в этот шаг:</b> {{ modal.step.ui_description }}</p>
          <p v-if="modal.topic"><b>Что входит в эту тему:</b> {{ modal.topic.ui_description }}</p>
          <p v-if="modal.stats?.topics">Характеристики ниже — это уточнения темы. Они показывают, что именно в этой теме
            чаще встречается в
            отзывах.</p>
        </div>
        <div class="modal__cell-ai" v-if="modal.stats?.hypothesis" id="modal-cell-ai">
          <div class="modal-cell-ai__title">Гипотезы, почему так много негативных отзывов по этой теме</div>
          <p class="modal-cell-ai__period">Выводы подготовлены на основе отзывов за период <span
              class="period">{{ company.period }}</span>
            <button class="btn btn-sm" @click="setDate(company.period)">показать период</button>
          </p>
          <ol class="modal-cell-ai__list">
            <li v-for="cause in modal.stats.hypothesis.cause_hypotheses">{{ cause }}</li>
          </ol>
        </div>
        <div class="modal__body">
          <div v-if="modal.stats?.channels">
            <div class="modal__col-title">Каналы</div>
            <div class="modal__col-hint">канал взаимодействия со страховой компанией</div>
            <div id="modal-channels">
              <div class="row" v-for="channel in modal.stats.channels" :data-key="channel.id"
                   :data-label="channel.label">
                <div class="row__top">
                  <div class="row__name">{{ channel.label }}</div>
                  <div class="row__count mono">{{ $pluralise(channel.total, ['отзыв', 'отзыва', 'отзывов']) }}</div>
                </div>
                <div class="row__bar"
                     :aria-label="$pluralise(channel.total, ['отзыв', 'отзыва', 'отзывов'])+' в этом срезе'">
                  <div class="row__bar-track">
                    <div class="row__bar-fill"
                         :style="{width:  Math.max(3, Math.min(100, ((channel.total || 0) / Math.max(1, modal.stats.total)) * 100))+'%'}"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="modal__col-title">Характеристики</div>
            <div class="modal__col-hint">уточнение темы</div>
            <div id="modal-l2s" v-if="modal?.stats?.topics?.length">
              <div class="row" v-for="topic in modal.stats.topics" data-key="settlement_timing::l2_6"
                   :data-label="topic.label">
                <div class="row__top">
                  <div class="row__name">{{ topic.label }}</div>
                  <div class="row__count mono">{{ $pluralise(topic.total, ['отзыв', 'отзыва', 'отзывов']) }}</div>
                </div>
                <div class="row__bar"
                     :aria-label="$pluralise(topic.total, ['отзыв', 'отзыва', 'отзывов'])+' в этом срезе'">
                  <div class="row__bar-track">
                    <div class="row__bar-fill"
                         :style="{width:  Math.max(3, Math.min(100, ((topic.total || 0) / Math.max(1, modal.stats.total)) * 100))+'%'}"></div>
                  </div>
                </div>

              </div>
            </div>
            <div id="modal-l2s" v-else>
              <div style="color: var(--ink-4); font-size: var(--t-sm); padding: var(--s-3) 0;">Нет данных</div>
            </div>
          </div>
          <div class="modal__trend" v-if="modal.chart" id="modal-trend">
            <div class="modal-trend__title">Динамика темы</div>
            <Line
                :options="modal.chart.options"
                :data="modal.chart.data"
            />
          </div>
          <div class="modal__examples">
            <div class="modal__col-title">Примеры отзывов</div>
            <div class="modal__col-hint">тексты отзывов из выборки</div>
            <div id="modal-examples">
              <div class="example-list">
                <div class="example" v-for="review in modal.stats?.reviews">
                  <div class="example__text">«{{ review.review_text }}»
                  </div>

                  <div class="example__meta"><span class="example__tag">{{ review.id }}</span><span
                      class="example__tag" v-if="review.product">{{ review.product_filter_value }}</span>
                    <span class="example__tag" v-if="review.city">{{ review.city }}</span>
                    <span class="example__tag" v-if="review.step">{{ review.step }}</span>
                    <span class="example__tag" v-if="review.channel">{{ review.channel }}</span>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

      </template>
      <template v-slot:footer>
        <div class="modal__footer-actions">
          <!--          <button class="btn btn&#45;&#45;ghost" id="modal-download">Скачать Excel</button>-->
          <router-link class="btn btn--primary" target="_blank"
                       @click="goToReview(getReviewName(modal.step, modal.topic), modal.stats.review_ids)"
                       :to="{name: 'project_reviews'}">
            Открыть {{ $pluralise(modal.stats?.total, ['отзыв', 'отзыва', 'отзывов']) }}
          </router-link>

        </div>
      </template>
    </modal>


  </div>


</template>

<script>


import {Line} from "vue-chartjs";
import {Chart as ChartJS, Title, Tooltip, Legend, LineElement, CategoryScale, LinearScale, PointElement} from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(Title, Tooltip, Legend, LineElement, CategoryScale, LinearScale, PointElement, ChartDataLabels)
ChartJS.defaults.plugins.legend.display = false;
import TopBlock from "@/components/TopBlock.vue";
import CustomPopover from "@/components/CustomPopover.vue";
import AiSummary from "@/views/business/AiSummary.vue";
import {AnalyticsApi} from "@/api/analytics";
import HmCell from "@/views/business/components/HmCell.vue";
import datesMixin from "@/mixins/filterDates";
import {ReportApi} from "@/api/report";

export default {
  name: 'ProjectBusiness',
  mixins: [datesMixin],
  data() {
    return {
      objects: [],
      openFilter: false,
      load: false,
      reportLoaded: false,
      filters: {
        product: null,
        city: null,
        tone: "negative",
      },
      company: {},
      params: {
        cur: 0,
        prev: 0,
        norm: 0
      },
      modal: {},
      heatmapColorLevels: {},
      palettes: {
        all: {
          label: 'все',
          title: 'Все отзывы',
          legendTitle: 'Цвет ячейки — объём всех отзывов',
          top: '#1D4ED8',
          buckets: [
            {from: 0, to: 25, background: '#F8FAFC', color: '#000000'},
            {from: 25, to: 50, background: '#DBEAFE', color: '#000000'},
            {from: 50, to: 75, background: '#93C5FD', color: '#000000'},
            {from: 75, to: 100, background: '#3B82F6', color: '#ffffff', invert: true}
          ]
        },
        negative: {
          label: 'негатив',
          title: 'Негативные отзывы',
          legendTitle: 'Цвет ячейки — объём негативных отзывов',
          top: '#B0341A',
          buckets: [
            {from: 0, to: 25, background: '#F8FAFC', color: '#000000'},
            {from: 25, to: 50, background: '#F4E1DA', color: '#000000'},
            {from: 50, to: 75, background: '#E4A58E', color: '#000000'},
            {from: 75, to: 100, background: '#C7674C', color: '#ffffff', invert: true}
          ]
        },
        positive: {
          label: 'не негатив',
          title: 'Позитивные отзывы',
          legendTitle: 'Цвет ячейки — объём позитивных отзывов',
          top: '#15803D',
          buckets: [
            {from: 0, to: 25, background: '#F8FAFC', color: '#000000'},
            {from: 25, to: 50, background: '#DCFCE7', color: '#000000'},
            {from: 50, to: 75, background: '#86EFAC', color: '#000000'},
            {from: 75, to: 100, background: '#22C55E', color: '#ffffff', invert: true}
          ]
        }

      },
      delayed: false,
      options: {
        responsive: true,
        maintainAspectRatio: false,
        layout: {padding: 20},
        elements: {point: {radius: 2}},
        scales: {
          x: {
            ticks: {
              autoSkip: true
            },
            grid: {display: false}
          },
          y: {
            grid: {display: false},
            ticks: {display: false},
            min: 0,
          },
        },
        interaction: {mode: 'index', intersect: false},
        plugins: {
          legend: {display: false},
          datalabels: {
            align: 'top',
            offset: 0,
            font: {
              weight: 'bold',
              size: 11
            },
            formatter: (current, context) => {
              return context.dataset.labels[context.dataIndex]
            }
          }
        }
      }
    }
  },
  components: {
    Line,
    HmCell,
    AiSummary, TopBlock, CustomPopover
  },
  watch: {},
  computed: {
    reviews() {
      return this.filterReview();
    },
    project: {
      get() {
        return this.$store.getters.currentProject
      }
    },
    table() {
      let table = {
        steps: [],
        topics: [],
        groups: [],
        cells: [],
        total: {
          steps: 0
        },

      }
      this.company.steps?.forEach(step => {
        table.steps.push({step: step, stats: this.cellStats(null, step)});
      });
      table.total.steps = Math.max(0, ...table.steps.map(x => x.stats.total));

      this.company.groups?.forEach(group => {
        let t_group = {label: group.label, color: group.color, topics: []}
        group.topics?.forEach(topic_l1 => {
          t_group.topics.push({topic: {...topic_l1, ...{color: group.color}}, stats: this.cellStats(topic_l1, null)})
          this.company.steps?.forEach(step => {
            table.cells.push({
              topic: {...topic_l1, ...{color: group.color}},
              step: step,
              stats: this.cellStats(topic_l1, step)
            });
          });
        });
        table.groups.push(t_group)
      });
      this.heatmapColorLevels = this.buildHeatmapColorLevels(table.cells);
      return table
    },
  },
  mounted: function () {
    let filters = {}
    filters.date_after = this.date_from
    filters.date_before = this.date_to
    const searchParams = new URLSearchParams();
    for (const [key, value] of Object.entries(filters)) {
      if (value === null || value === undefined) {
        continue;
      }
      searchParams.append(key, value);
    }
    const queryString = searchParams.toString();
    AnalyticsApi.dictionary(queryString).then(response => {
      this.company = response;
    })
    this.startRequest()
  },
  methods: {
    fileResponse: function (response, name) {
      const url = window.URL.createObjectURL(response);
      const link = document.createElement('a');
      link.href = url;
      link.download = name;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    },
    loadHtml() {
      this.reportLoaded = true;
      AnalyticsApi.download_html(this.date_from, this.date_to).then((response) => {
        this.fileResponse(response, this.project.name+"_barriers_map.html")
        this.reportLoaded = false;
      }).catch(e=>this.reportLoaded = false);
    },
    getGlobalIndex(groupIndex, topicIndex) {
      let count = 0;
      for (let i = 0; i < groupIndex; i++) {
        count += this.table.groups[i].topics.length;
      }
      return String(count + topicIndex + 1).padStart(2, '0');
    },

    setDate(period) {
      let [start, end] = period.split('-')
      this.$store.dispatch('setFilterDates', {from: this.$moment(start, 'DD.MM').format('YYYY-MM-DD'), to: false})
      this.$store.dispatch('setFilterDates', {from: false, to: this.$moment(end, 'DD.MM').format('YYYY-MM-DD')})
      this.$modal('hide', 'detail_info')

    },
    getReviewName(step, topic) {
      let values = [`${this.$moment(this.date_from).format('DD.MM')}-${this.$moment(this.date_to).format('DD.MM')}`];
      if (step) values.push(step.ui_label)
      if (topic) values.push(topic.ui_label)
      return values.join('×')
    },
    goToReview(name, ids) {
      localStorage.setItem(`pendingReviewIds_${this.project.id}`, JSON.stringify({name: name, ids: ids}))
    },
    getData(signal) {
      this.load = true;
      let filters = {}
      filters.date_after = this.date_from
      filters.date_before = this.date_to
      const searchParams = new URLSearchParams();
      for (const [key, value] of Object.entries(filters)) {
        if (value === null || value === undefined) {
          continue;
        }
        searchParams.append(key, value);
      }
      const queryString = searchParams.toString();
      AnalyticsApi.get_reviews(queryString, signal).then(response => {
        this.objects = response;
        this.load = false
        this._startRequrst = false;
      }).catch((e) => {
        throw e;
      })

    },

    openModal(step, topic, stats) {

      this.modal = {step: step, topic: topic, stats: stats}
      let filters = {}
      filters.step = step?.id
      filters.topic = topic?.id
      filters.tone = this.filters.tone !== "all" ? this.filters.tone : "";
      filters.date_after = this.date_from
      filters.date_before = this.date_to
      // if (this.filters.city) filters.city = this.filters.city.id
      if (this.filters.product) filters.product = this.filters.product.id
      const searchParams = new URLSearchParams();
      for (const [key, value] of Object.entries(filters)) {
        if (value === null || value === undefined) {
          continue;
        }
        searchParams.append(key, value);
      }
      const queryString = searchParams.toString();
      this.modal.chart = null
      AnalyticsApi.get_chart(queryString).then(response => {
        this.modal.chart = {}
        this.modal.chart.data = {
          labels: response.map(x => x.label),
          datasets: [{
            data: response.map(x => x.count),
            labels: response.map(x => x.count),
            borderColor: this.palettes[this.filters.tone].top,
            backgroundColor: this.palettes[this.filters.tone].top,
            fill: false,
            tension: 0.4
          }]
        }
        this.modal.chart.options = this.options
      })
      this.$modal('show', 'detail_info')

    },

    buildHeatmapColorLevels(cells) {
      const coloredTotals = cells
          .map(c => c.stats.total)
          .filter(total => total >= 2)
          .sort((a, b) => a - b);
      const uniqueTotals = [...new Set(coloredTotals)];
      const levels = new Map();
      if (uniqueTotals.length === 0) return levels;
      if (uniqueTotals.length === 1) {
        levels.set(uniqueTotals[0], coloredTotals.length === 1 ? 4 : 2);
        return levels;
      }
      uniqueTotals.forEach((total, index) => {
        levels.set(total, Math.round((index / (uniqueTotals.length - 1)) * 4));
      });
      return levels;
    },

    fmtDelta(pct) {
      if (pct === '—') return '—'
      if (Math.abs(pct) < 0.5) return '±0%';
      const arrow = pct > 0 ? '↑' : '↓';
      const sign = pct > 0 ? '+' : '';
      return `${arrow} ${sign}${pct.toFixed(0)}%`;
    },
    handlePopoverToggle(event) {
      const popover = this.$refs.popover

      if (popover) {
        if (popover.visible) {
          popover.close()
        } else {
          popover.open(event)
        }
      }
    },
    filterReview() {
      let reviews = this.objects.filter(r => {
        if (this.filters.product?.name) {
          const hasProduct = r.products?.some(
              product => product.toLowerCase() === this.filters.product.name.toLowerCase()
          );
          if (!hasProduct) return false;
        }
        return !(this.filters.tone !== 'all' && r.management_sentiment !== this.filters.tone);

      });
      this.params.cur = reviews.filter(r => !this.reviewPeriod(r)).length;
      this.params.prev = reviews.filter(r => this.reviewPeriod(r)).length;
      this.params.norm = this.params.prev > 0 && this.params.cur > 0 ? this.params.cur / this.params.prev : 1;
      return reviews
    },
    reviewMatchesTopicL1(review, topic_l1) {
      if (topic_l1.no_topic) return !review.topics.length;
      return review.topics.some(t => t.l1 === topic_l1.slug);
    },
    reviewPeriod(review) {
      return parseInt(review.period);
    },

    drillChannels(curPool, prevPool) {
      return this.company.channels.map(ch => {
        const cur = curPool.filter(r => r.channel === ch.label);
        const prev = prevPool.filter(r => r.channel === ch.label);
        const total = cur.length;
        const neg = cur.filter(r => r.management_sentiment === 'негатив').length;
        const prevNorm = prev.length * this.params.norm;
        return {
          key: ch,
          label: ch.ui_label || ch.label,
          total, neg,
          negPct: total > 0 ? (neg / total) * 100 : 0,
          deltaPct: prevNorm > 0 ? ((total - prevNorm) / prevNorm) * 100 : '—'
        };
      }).filter(r => r.total > 0)
          .sort((a, b) => b.total - a.total);
    },
    getTopicsL2Statistics(rows, topic_l1) {
      if (!topic_l1) return []
      const stats = {};

      rows.forEach(row => {
        if (row.topics && Array.isArray(row.topics)) {
          row.topics.forEach(topic => {
            if (topic.l1 === topic_l1?.slug && topic.l2 && Array.isArray(topic.l2)) {
              topic.l2.forEach(l2Item => {
                if (stats[l2Item]) {
                  stats[l2Item]++;
                } else {
                  stats[l2Item] = 1;
                }
              });
            }
          });
        }
      });

      return Object.entries(stats).map(([topic_name, count]) => ({
        label: topic_name,
        total: count
      })).filter(r => r.total > 0)
          .sort((a, b) => b.total - a.total);
    },
    getCellHypothesis(step, topic) {
      let hypothises = null
      if (step && topic && this.company.heatmap_hypotheses) {
        const key = `${step.slug}|${topic.slug}`
        hypothises = this.company.heatmap_hypotheses.find(x => x.cell_key === key) || null
      }
      return hypothises

    },

    cellStats(topic_l1, step) {
      let reviews = this.reviews;
      if (topic_l1) reviews = reviews.filter(r => this.reviewMatchesTopicL1(r, topic_l1));
      if (step) reviews = reviews.filter(r => r.cjm_step_v1 === step.slug);

      const cur = reviews.filter(r => !this.reviewPeriod(r));
      const prev = reviews.filter(r => this.reviewPeriod(r));


      const total = cur.length;
      const neg = cur.filter(r => r.management_sentiment === 'негатив').length;
      // const prevNorm = prev.length * this.params.norm;
      const prevNorm = prev.length;
      return {
        total,
        neg,
        hypothesis: this.getCellHypothesis(step, topic_l1),
        channels: this.drillChannels(cur, prev),
        topics: this.getTopicsL2Statistics(reviews, topic_l1),
        reviews: cur.slice(0, 3),
        review_ids: cur.map(x => x.review_id),
        negPct: total > 0 ? (neg / total) * 100 : 0,
        prev: prevNorm,
        deltaPct: prevNorm > 0 ? ((total - prevNorm) / prevNorm) * 100 : '—'
      };
    },

  }
}

</script>
<style lang="scss">

.business {
  /* === Surfaces === */
  --bg: #F4F6FA;
  --surface: #FFFFFF;
  --surface-2: #F8FAFC;
  --line: #E5E7EB;
  --line-strong: #CBD5E1;

  /* === Ink (text) === */
  --ink: #1F2937;
  --ink-2: #4B5563;
  --ink-3: #6B7280;
  --ink-4: #9CA3AF;

  /* === Accent (primary blue) === */
  --accent: #2563EB;
  --accent-hover: #1D4ED8;
  --accent-soft: #DBEAFE;
  --accent-softer: #EFF6FF;
  --accent-border: #BED2F4;

  /* === Negative === */
  --neg: #B0341A;
  --neg-soft: #F4E1DA;
  --neg-track: #EDD9D1;

  /* === Positive === */
  --pos: #15803D;
  --pos-soft: #DCFCE7;

  /* === Topic colors === */
  --t-operations: #5C7A99;
  --t-digital: #7C5BA8;
  --t-communication: #B7791F;
  --t-data: #6B7E3C;
  --t-staff: #2C7166;
  --t-product: #9D4E68;
  --t-partners: #4C5DAB;
  --t-other: #94A3B8;

  /* === Heatmap intensity scale === */
  --hm-0: #F8FAFC;
  --hm-25: #F4E1DA;
  --hm-50: #E4A58E;
  --hm-75: #C7674C;
  --hm-100: #B0341A;
  --hm-active-color: var(--neg);

  /* === Shadows === */
  --shadow-sm: 0 1px 2px rgba(15, 23, 42, 0.04);
  --shadow-md: 0 1px 3px rgba(15, 23, 42, 0.06), 0 1px 2px rgba(15, 23, 42, 0.04);
  --shadow-lg: 0 4px 12px rgba(15, 23, 42, 0.08), 0 2px 4px rgba(15, 23, 42, 0.04);

  /* === Spacing scale === */
  --s-1: 4px;
  --s-2: 8px;
  --s-3: 12px;
  --s-4: 16px;
  --s-5: 24px;
  --s-6: 32px;

  /* === Radius scale === */
  --r-sm: 4px;
  --r-md: 8px;
  --r-lg: 12px;

  /* === Type scale === */
  --t-xs: 11px;
  --t-sm: 12px;
  --t-base: 14px;
  --t-md: 16px;
  --t-lg: 20px;
  --t-xl: 24px;

  /* === Δ semantics (override-able) === */
  --delta-up: var(--neg); /* рост — плохо (по умолчанию для негатива) */
  --delta-down: var(--pos); /* снижение — хорошо */
  --delta-up-inverted: #FFC9B5;
  --delta-down-inverted: #BCE6CF;

  /* === Fonts === */
  --font-ui: 'Inter', system-ui, -apple-system, sans-serif;
  --font-mono: 'JetBrains Mono', ui-monospace, monospace;

  &[data-management-sentiment="positive"] {
    --delta-up: var(--pos);
    --delta-down: var(--neg);
    --delta-up-inverted: #D1FAE5;
    --delta-down-inverted: #FECACA;
    --hm-active-color: var(--pos);
  }

  &[data-management-sentiment="all"] {
    --delta-up: var(--ink-2);
    --delta-down: var(--ink-2);
    --delta-up-inverted: rgba(255, 255, 255, 0.8);
    --delta-down-inverted: rgba(255, 255, 255, 0.8);
    --hm-active-color: var(--accent);
  }

  background: #F4F6FA;


  .filters {
    border-bottom: 1px solid #E5E7EB;
    padding-bottom: 20px;

    .filter-info {
      margin-left: auto;
      color: #6B7280;
      text-transform: uppercase;
      letter-spacing: 0.04em;

      display: flex;
      align-items: center;
      gap: 10px;

      .mono {
        color: #2563EB;
      }

      .period-info {
        font-size: 12px;
        text-transform: none;

        .line {
          display: flex;
          gap: 10px;
          justify-content: end;
        }

        .date {
          font-weight: 600;
        }
      }
    }
  }


  .section-head {

    .section-title-row {
      display: flex;
      align-items: baseline;
      justify-content: start;
      gap: 10px;

      .section-title {
        font-size: 16px;
        font-weight: 700;
        margin: 0;
      }

      .help-btn {
        width: 22px;
        height: 22px;
        border-radius: 50%;
        border: 1px solid #CBD5E1;
        color: #6B7280;
        font-size: 11px;
        font-weight: 700;
        background: #FFFFFF;
      }

      .help-btn:hover {
        border-color: var(--accent);
        color: var(--accent);
        background: var(--accent-softer);
      }

    }


    .section-note {
      margin-top: 10px;
      font-size: 12px;
      color: #6B7280;
      line-height: 1.55;
    }
  }

  /* ============================================================
     POPOVER (filter dropdown)
     ============================================================ */
  .popover {
    position: fixed;
    background: var(--surface);
    border: 1px solid var(--line-strong);
    border-radius: var(--r-md);
    box-shadow: var(--shadow-lg);
    padding: var(--s-1);
    z-index: 100;
    min-width: 200px;
    max-height: 360px;
    overflow-y: auto;
  }

  .popover__item {
    padding: 7px var(--s-3);
    border-radius: 3px;
    cursor: pointer;
    font-size: var(--t-sm);
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--s-2);
  }

  .popover__item:hover {
    background: var(--bg);
  }

  .popover__item--selected {
    background: var(--accent);
    color: var(--surface);
  }

  .popover__item--selected:hover {
    background: var(--accent-hover);
  }

  /* ============================================================
     MAIN
     ============================================================ */

  .summary-line {
    display: flex;
    align-items: flex-start;
    gap: var(--s-3);
    padding: var(--s-3) var(--s-4);
    background: var(--surface);
    border: 1px solid var(--line);
    border-left: 3px solid var(--accent);
    border-radius: var(--r-md);
    box-shadow: var(--shadow-sm);
    margin-bottom: var(--s-4);
    color: var(--ink-2);
    line-height: 1.5;
  }

  .summary-line__label {
    font-size: 10px;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: var(--accent);
    font-weight: 700;
    flex-shrink: 0;
    padding-top: 2px;
  }

  .summary-line b {
    color: var(--ink);
  }

  .summary-line__content {
    display: grid;
    gap: 3px;
  }

  .summary-line__muted {
    color: var(--ink-3);
  }

  .summary-line__count-note {
    display: inline-block;
    margin-left: var(--s-2);
    padding: 2px 6px;
    border-radius: 4px;
    background: var(--accent-softer);
    color: var(--ink-2);
    font-size: var(--t-xs);
  }

  .reading-guide {
    display: grid;
    gap: var(--s-2);
    margin: 0 0 var(--s-3);
  }

  .reading-guide__title {
    font-size: var(--t-sm);
    font-weight: 700;
    color: var(--ink);
  }

  .reading-guide__items {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: var(--s-2);
  }

  .reading-guide__item {
    display: flex;
    align-items: flex-start;
    gap: var(--s-2);
    padding: var(--s-3);
    border: 1px solid var(--line);
    border-radius: var(--r-sm);
    background: var(--accent-softer);
    color: var(--ink-2);
    font-size: var(--t-xs);
    line-height: 1.45;
  }

  .reading-guide__label {
    color: var(--ink);
    font-weight: 700;
    flex-shrink: 0;
  }

  .hm-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--s-2);
    margin: 0 0 var(--s-3);
  }

  .hm-toolbar__label {
    font-size: var(--t-xs);
    color: var(--ink-3);
  }

  .segmented {
    display: inline-flex;
    padding: 2px;
    border: 1px solid var(--line);
    border-radius: var(--r-sm);
    background: var(--surface);
  }

  .segmented__btn {
    padding: 6px 10px;
    border-radius: 4px;
    font-size: var(--t-xs);
    color: var(--ink-3);
    font-weight: 600;
  }

  .segmented__btn--active {
    background: var(--accent-soft);
    color: var(--accent);
  }

  .filter-hint {
    width: 100%;
    font-size: var(--t-xs);
    color: var(--ink-3);
    display: none;
    align-items: center;
    gap: var(--s-2);
    padding-top: var(--s-1);
  }

  .filter-hint--visible {
    display: flex;
  }

  .filter-hint button {
    color: var(--accent);
    font-weight: 600;
    font-size: var(--t-xs);
  }

  .empty-state {
    position: relative;
    padding: var(--s-5);
    background: var(--surface);
    border: 1px dashed var(--line-strong);
    border-radius: var(--r-md);
    color: var(--ink-3);
    margin-top: var(--s-4);

    &.loading {
      span {
        display: none;
      }
    }
  }

  .empty-state--visible {
    display: block;
  }

  .empty-state b {
    color: var(--ink);
  }

  .help-popover {
    display: none;
    position: fixed;
    z-index: 120;
    width: 440px;
    background: var(--surface);
    border: 1px solid var(--line-strong);
    border-radius: var(--r-md);
    box-shadow: var(--shadow-lg);
    padding: var(--s-4);
    color: var(--ink-2);
    font-size: var(--t-sm);
    line-height: 1.5;
  }

  .help-popover--visible {
    display: block;
  }

  .help-popover h3 {
    margin: 0 0 var(--s-2);
    font-size: var(--t-base);
    color: var(--ink);
  }

  .help-popover p {
    margin: 0 0 var(--s-2);
  }

  .help-popover p:last-child {
    margin-bottom: 0;
  }

  .help-popover__spaced {
    margin-top: var(--s-3);
  }

  .help-popover__count-rule {
    margin-top: var(--s-3);
    padding: var(--s-2) var(--s-3);
    border-radius: var(--r-sm);
    background: var(--accent-softer);
    border: 1px solid var(--accent-border);
    color: var(--ink);
    font-weight: 600;
  }

  /* ============================================================
     HEATMAP SHELL
     [corner] [top axis - CJM cards]
     [left  ] [body - heatmap cells]
     ============================================================ */
  .hm-shell {
    position: relative;
    display: grid;
    grid-template-columns: 340px minmax(0, 1fr);
    grid-template-rows: auto auto;
    column-gap: var(--s-3);
    row-gap: var(--s-3);
    align-items: start;
  }

  /* === Corner: легенда === */
  .hm-corner {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    padding: 0 var(--s-1) var(--s-2);
    min-height: 200px;
    gap: var(--s-3);
    top: 70px;
    background: #F4F6FA;
  }

  .topic-axis-head {
    display: grid;
    gap: var(--s-2);
    padding: var(--s-3);
    background: var(--surface);
    border: 1px solid var(--line);
    border-radius: var(--r-sm);
    box-shadow: var(--shadow-sm);
  }

  .topic-axis-head__title {
    font-size: var(--t-sm);
    font-weight: 700;
    color: var(--ink);
  }

  .legend {
    display: flex;
    flex-direction: column;
    gap: var(--s-2);
    font-size: var(--t-xs);
    color: var(--ink-3);
    letter-spacing: 0.02em;
  }

  .legend__title {
    text-transform: uppercase;
    font-weight: 600;
    letter-spacing: 0.06em;
    color: var(--ink-2);
    font-size: 10px;
  }

  .legend__scale-row {
    display: flex;
    gap: 0;
    align-items: stretch;
    border-radius: var(--r-sm);
    overflow: hidden;
    border: 1px solid var(--line);
  }

  .legend__scale-step {
    flex: 1;
    height: 18px;
    position: relative;
  }

  .legend__scale-row + .legend__scale-labels {
    display: flex;
    margin-top: var(--s-1);
    font-family: var(--font-mono);
    font-size: 10px;
    color: var(--ink-3);
    justify-content: space-between;
    padding: 0 1px;
  }

  .legend__low {
    display: inline-flex;
    align-items: center;
    gap: var(--s-1);
    font-family: var(--font-mono);
    font-size: 10px;
  }

  .legend__low-mark {
    display: inline-block;
    width: 14px;
    height: 14px;
    background: repeating-linear-gradient(45deg, var(--bg) 0 3px, var(--surface) 3px 6px);
    border: 1px solid var(--line);
    border-radius: 3px;
  }

  /* ============================================================
     CJM CARDS (top axis)
     ============================================================ */
  .hm-top-axis {
    display: grid;

    gap: 0;
    min-width: 0;
    top: 70px;
    background: #F4F6FA;
  }

  .cjm-card {
    background: var(--accent-soft);
    border: 1px solid var(--accent-border);
    border-radius: var(--r-md);
    margin: 0 5px;
    padding: 0;
    min-height: 200px;
    height: auto;
    display: flex;
    flex-direction: column;
    position: relative;
    box-shadow: var(--shadow-sm);
    transition: box-shadow 0.15s, transform 0.15s, border-color 0.15s;
    overflow: hidden;
    cursor: pointer;
  }

  .cjm-card:hover {
    box-shadow: var(--shadow-md);
    transform: translateY(-1px);
    border-color: var(--accent);
  }

  .cjm-card:first-child {
    margin-left: 0;
  }

  .cjm-card:last-child {
    margin-right: 0;
  }

  .cjm-card__track {
    height: 48px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .cjm-card__track::before {
    content: '';
    position: absolute;
    left: -6px;
    right: -6px;
    top: 50%;
    height: 3px;
    background: var(--accent);
    transform: translateY(-50%);
    z-index: 1;
  }

  .cjm-card:first-child .cjm-card__track::before {
    left: 50%;
  }

  .cjm-card:last-child .cjm-card__track::before {
    right: 50%;
  }

  .cjm-card--before-no-step .cjm-card__track::before {
    right: 50%;
  }

  .cjm-card__dot {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: var(--accent);
    color: var(--surface);
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: var(--font-mono);
    font-weight: 700;
    font-size: var(--t-sm);
    letter-spacing: 0.02em;
    position: relative;
    z-index: 2;
    border: 4px solid var(--accent-soft);
    box-sizing: content-box;
    box-shadow: 0 0 0 1px var(--accent);
  }

  .cjm-card__content {
    flex: 1;
    padding: var(--s-1) var(--s-4) var(--s-4);
    display: flex;
    flex-direction: column;
  }

  .cjm-card__name {
    font-size: 13px;
    font-weight: 700;
    color: var(--ink);
    line-height: 1.25;
    text-align: center;
    margin-bottom: var(--s-3);
    min-height: 48px;
    letter-spacing: 0;
    overflow: visible;
    white-space: normal;
    overflow-wrap: anywhere;
  }

  .bottom {
    margin-top: auto;
  }

  .cjm-card__nums {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--s-1);
  }

  .cjm-card__total {
    font-family: var(--font-mono);
    font-size: var(--t-xl);
    font-weight: 700;
    color: var(--ink);
    letter-spacing: -0.02em;
    line-height: 1;
  }

  .cjm-card__delta {
    font-family: var(--font-mono);
    font-size: var(--t-sm);
    color: var(--ink-3);
    font-weight: 500;
  }

  .cjm-card__delta--up {
    color: var(--delta-up);
    font-weight: 700;
  }

  .cjm-card__delta--down {
    color: var(--delta-down);
    font-weight: 700;
  }

  .cjm-card__bar {
    height: 6px;
    background: rgba(37, 99, 235, 0.18);
    border-radius: 3px;
    overflow: hidden;
    display: flex;
    margin-top: 5px;
  }

  .cjm-card__bar-fill {
    height: 100%;
    background: var(--hm-active-color);
  }

  .cjm-card__no-data {
    font-size: 10px;
    color: var(--ink-4);
    margin-top: auto;
  }

  .cjm-card--no-step {
    background: #F3F4F6;
    border-color: #D1D5DB;
  }

  .cjm-card--no-step:hover {
    border-color: #9CA3AF;
  }

  .cjm-card--no-step .cjm-card__track {
    height: 28px;
  }

  .cjm-card--no-step .cjm-card__track::before {
    display: none;
  }

  .cjm-card--no-step .cjm-card__dot {
    display: none;
  }

  .cjm-card--no-step .cjm-card__bar {
    background: rgba(107, 114, 128, 0.18);
  }

  .cjm-card--empty {
    opacity: 0.5;
    cursor: default;
  }

  .cjm-card--empty:hover {
    transform: none;
    box-shadow: var(--shadow-sm);
    border-color: var(--accent-border);
  }

  .cjm-card--empty.cjm-card--no-step:hover {
    border-color: #D1D5DB;
  }

  .cjm-card--empty .cjm-card__total {
    color: var(--ink-3);
  }

  .cjm-card--empty .cjm-card__dot {
    background: var(--ink-4);
    box-shadow: 0 0 0 1px var(--ink-4);
  }

  .cjm-card--empty .cjm-card__track::before {
    background: var(--line-strong);
  }

  .cjm-card--empty.cjm-card--no-step .cjm-card__track::before {
    background: #D1D5DB;
  }

  /* ============================================================
     TOPIC CARDS (left axis) — цветные маркеры
     ============================================================ */
  .hm-left-axis {
    display: grid;
    grid-template-columns: 138px 1fr;
    grid-auto-rows: 70px;
    column-gap: 0;
    row-gap: var(--s-1);
    align-items: stretch;
  }

  .topic-group-label {
    grid-column: 1;
    display: flex;
    align-items: center;
    padding: var(--s-2) var(--s-3);
    color: var(--group-color, var(--ink-2));
    font-size: 13px;
    font-weight: 600;
    line-height: 1.2;
    background: var(--surface);
    border-left: 3px solid var(--group-color, var(--accent));
    border-right: 1px solid var(--line);
    box-shadow: var(--shadow-sm);
  }

  .topic-group-label--first {
    border-top: 1px solid var(--line);
    border-top-left-radius: var(--r-sm);
  }

  .topic-group-label--last {
    border-bottom: 1px solid var(--line);
    border-bottom-left-radius: var(--r-sm);
  }

  .theme-card {
    grid-column: 3;
    background: var(--surface);
    border: 1px solid var(--line);
    border-radius: var(--r-md);
    min-height: 70px;
    padding: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--s-3);
    position: relative;
    //overflow: hidden;
    box-shadow: var(--shadow-sm);
    transition: box-shadow 0.15s, border-color 0.15s, transform 0.15s;
    cursor: pointer;
  }

  .theme-card:hover {
    box-shadow: var(--shadow-md);
    border-color: var(--line-strong);
    transform: translateX(1px);
  }

  .theme-card::before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 4px;
    background: var(--theme-color, var(--accent));
    border-radius: 10px 0 0 10px;
  }

  .theme-card__name {
    font-size: var(--t-base);
    font-weight: 700;
    color: var(--ink);
    line-height: 1.2;
    letter-spacing: -0.01em;
  }

  .theme-card--other .theme-card__name {
    font-weight: 500;
    font-style: italic;
    color: var(--ink-3);
  }

  .theme-card__metrics {
    text-align: right;
    flex-shrink: 0;
    margin-left: auto;
  }

  .theme-card__number {
    font-weight: 600;
    font-size: 12px;
    z-index: 2;
    position: absolute;
    top: 50%;
    transform: translateY(-50%) translateX(-50%);
    left: -17px;
  }

  .theme-card__total {
    font-family: var(--font-mono);
    font-size: var(--t-lg);
    font-weight: 700;
    color: var(--ink);
    line-height: 1;
    letter-spacing: -0.02em;
  }

  .theme-card__delta {
    font-family: var(--font-mono);
    font-size: var(--t-xs);
    color: var(--ink-3);
    margin-top: var(--s-1);
    font-weight: 500;
  }

  .theme-card__delta--up {
    color: var(--delta-up);
    font-weight: 700;
  }

  .theme-card__delta--down {
    color: var(--delta-down);
    font-weight: 700;
  }

  .theme-card--empty .theme-card__total {
    color: var(--ink-4);
  }

  /* ============================================================
     HEATMAP BODY
     ============================================================ */
  .hm-body {
    display: grid;
    grid-auto-rows: auto;
    column-gap: var(--s-1);
    row-gap: var(--s-1);
    min-width: 0;
  }

  .hm-group-row {
    display: none;
  }

  .hm-cell {
    background: var(--surface);
    border: 1px solid var(--line);
    border-radius: var(--r-sm);
    min-height: 70px;
    padding: var(--s-2) var(--s-1);
    display: flex;
    flex-direction: column;
    justify-content: center;
    cursor: pointer;
    transition: outline 0.1s, box-shadow 0.1s;
    outline: 0px solid transparent;
    outline-offset: -2px;
    position: relative;
    box-shadow: var(--shadow-sm);
  }

  .hm-cell:hover {
    outline: 2px solid var(--accent);
    z-index: 5;
  }

  .hm-cell--low {
    background: repeating-linear-gradient(45deg, var(--bg) 0 5px, var(--surface) 5px 10px) !important;
    border-color: var(--line);
    box-shadow: none;
  }

  .hm-cell--zero {
    background: transparent;
    border-style: dashed;
    border-color: var(--line);
    cursor: default;
    box-shadow: none;
  }

  .hm-cell--zero:hover {
    outline: 0px solid transparent;
  }

  .hm-cell__count {
    font-family: var(--font-mono);
    font-size: var(--t-md);
    font-weight: 700;
    letter-spacing: -0.02em;
    line-height: 1.05;
    text-align: center;
  }

  .hm-cell__delta {
    font-family: var(--font-mono);
    font-size: 10px;
    text-align: center;
    margin-top: 3px;
    font-weight: 500;
    letter-spacing: -0.01em;
  }

  .hm-cell__delta--up {
    color: var(--delta-up);
    font-weight: 700;
  }

  .hm-cell__delta--down {
    color: var(--delta-down);
    font-weight: 700;
  }

  .hm-cell--zero .hm-cell__count {
    color: var(--ink-4);
    font-weight: 400;
  }

  .hm-cell--zero .hm-cell__delta {
    display: none;
  }

  /* На тёмных ячейках текст инвертируется */
  .hm-cell--inverted .hm-cell__count {
    color: var(--surface);
  }

  .hm-cell--inverted .hm-cell__delta {
    color: rgba(255, 255, 255, 0.7);
  }

  .hm-cell--inverted .hm-cell__delta--up {
    color: var(--delta-up-inverted);
  }

  .hm-cell--inverted .hm-cell__delta--down {
    color: var(--delta-down-inverted);
  }

  /* ============================================================
     TOOLTIP
     ============================================================ */
  .tooltip {
    position: fixed;
    background: var(--surface);
    border: 1px solid var(--line-strong);
    border-radius: var(--r-md);
    box-shadow: var(--shadow-lg);
    padding: var(--s-3) var(--s-3) var(--s-2);
    z-index: 10000;
    min-width: 280px;
    max-width: 320px;
    pointer-events: none;
    opacity: 0;
    transform: translateY(2px);
    transition: opacity 0.12s, transform 0.12s;
  }

  .tooltip--visible {
    opacity: 1;
    transform: translateY(0);
  }

  .tooltip__title {
    font-size: var(--t-sm);
    font-weight: 700;
    color: var(--ink);
    margin-bottom: var(--s-1);
    line-height: 1.3;
  }

  .tooltip__sub {
    font-family: var(--font-mono);
    font-size: 10px;
    color: var(--ink-3);
    text-transform: uppercase;
    letter-spacing: 0.06em;
    margin-bottom: var(--s-2);
    padding-bottom: var(--s-2);
    border-bottom: 1px solid var(--line);
  }

  .tooltip__group + .tooltip__group {
    margin-top: var(--s-2);
    padding-top: var(--s-2);
    border-top: 1px dashed var(--line);
  }

  .tooltip__group-label {
    font-size: 10px;
    text-transform: uppercase;
    color: var(--ink-3);
    letter-spacing: 0.06em;
    font-weight: 600;
    margin-bottom: var(--s-1);
  }

  .tooltip__row {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    gap: var(--s-2);
    font-size: var(--t-sm);
    padding: 2px 0;
  }

  .tooltip__row-name {
    color: var(--ink);
    flex: 1;
  }

  .tooltip__row-val {
    font-family: var(--font-mono);
    color: var(--ink-2);
    flex-shrink: 0;
  }

  .tooltip__hint {
    font-size: 10px;
    color: var(--ink-4);
    text-transform: uppercase;
    letter-spacing: 0.04em;
    margin-top: var(--s-2);
    padding-top: var(--s-2);
    border-top: 1px solid var(--line);
    text-align: center;
  }

  /* ============================================================
     MODAL
     ============================================================ */
  .modal-backdrop {
    position: fixed;
    inset: 0;
    background: rgba(20, 20, 18, 0.45);
    z-index: 300;
    display: none;
    align-items: center;
    justify-content: center;
    padding: var(--s-6);
  }

  .modal-backdrop--active {
    display: flex;
  }

  .modal {
    background: var(--surface);
    border-radius: var(--r-lg);
    max-width: 880px;
    width: 100%;
    max-height: calc(100vh - 64px);
    box-shadow: 0 24px 64px rgba(20, 20, 18, 0.2);
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  .modal__header {
    padding: var(--s-5) 72px var(--s-4) var(--s-5);
    border-bottom: 1px solid var(--line);
    display: flex;
    align-items: flex-start;
    gap: var(--s-6);
    position: relative;
  }

  .modal__head-main {
    flex: 1;
    min-width: 0;
  }

  .modal__crumbs {
    font-family: var(--font-ui);
    font-size: 10px;
    color: var(--ink-3);
    text-transform: uppercase;
    letter-spacing: 0.06em;
    margin-bottom: var(--s-1);
  }

  .modal__crumbs span {
    color: var(--ink);
    font-weight: 600;
  }

  .modal__crumbs em {
    font-style: normal;
    color: var(--ink-4);
    margin: 0 var(--s-1);
  }

  .modal__title {
    font-size: var(--t-md);
    font-weight: 700;
    letter-spacing: -0.01em;
    color: var(--ink);
    display: flex;
    align-items: center;
    gap: var(--s-2);
  }

  .modal__title-dot {
    width: 10px;
    height: 10px;
    border-radius: 3px;
    flex-shrink: 0;
    background: var(--accent);
  }

  .modal__head-stats {
    display: flex;
    gap: var(--s-5);
    flex-shrink: 0;
    padding-right: var(--s-3);
  }

  .modal__head-stat {
    text-align: right;
  }

  .modal__head-stat-label {
    font-size: 10px;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: var(--ink-3);
    margin-bottom: 2px;
  }

  .modal__head-stat-val {
    font-family: var(--font-mono);
    font-size: var(--t-md);
    font-weight: 700;
    color: var(--ink);
  }

  .modal__head-stat-val--neg {
    color: var(--neg);
  }

  .modal__close-btn {
    position: absolute;
    top: var(--s-4);
    right: var(--s-4);
    width: 28px;
    height: 28px;
    border-radius: var(--r-sm);
    color: var(--ink-3);
    font-size: var(--t-md);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.15s;
  }

  .modal__close-btn:hover {
    background: var(--bg);
    color: var(--ink);
  }

  .modal__body {
    padding: var(--s-4) var(--s-5);
    overflow-y: auto;
    flex: 1;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: var(--s-5);
  }

  .modal__context {
    margin: var(--s-4) var(--s-5) 0;
    padding: var(--s-3) var(--s-4);
    border: 1px solid var(--line);
    border-radius: var(--r-sm);
    background: var(--accent-softer);
    color: var(--ink-2);
    font-size: var(--t-sm);
    line-height: 1.5;
  }

  .modal__context-title {
    font-weight: 700;
    color: var(--ink);
    margin-bottom: var(--s-1);
  }

  .modal__context p {
    margin: 0;
  }

  .modal__context p + p {
    margin-top: var(--s-1);
  }

  .modal__trend {
    height: 300px;
    grid-column: 1 / -1;
    margin: 0;
    padding: var(--s-3) var(--s-4);
    border: 1px solid var(--line);
    border-radius: var(--r-sm);
    background: var(--surface);
  }

  .modal-trend__title {
    margin: 0 0 var(--s-2);
    font-family: var(--font-ui);
    font-size: var(--t-xs);
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: var(--ink-3);
  }

  .modal-trend__chart {
    width: 100%;
    height: 190px;
    display: block;
  }

  .modal-trend__empty {
    color: var(--ink-4);
    font-size: var(--t-sm);
    padding: var(--s-2) 0;
  }

  .modal-trend__axis {
    stroke: var(--line);
    stroke-width: 1;
  }

  .modal-trend__grid {
    stroke: var(--line);
    stroke-width: 1;
    stroke-dasharray: 4 4;
    opacity: 0.75;
  }

  .modal-trend__x-label {
    fill: var(--ink-3);
    font-family: var(--font-mono);
    font-size: 10px;
  }

  .modal-trend__point-label {
    fill: var(--ink);
    font-family: var(--font-mono);
    font-size: 11px;
    font-weight: 700;
  }

  .modal__col-title {
    font-size: var(--t-xs);
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: var(--ink-3);
    font-weight: 600;
    margin: 0 0 var(--s-1);
  }

  .modal__col-hint {
    font-size: 10px;
    color: var(--ink-4);
    font-family: var(--font-mono);
    text-transform: uppercase;
    letter-spacing: 0.04em;
    margin-bottom: var(--s-2);
  }

  .modal__examples {
    grid-column: 1 / -1;
    border-top: 1px solid var(--line);
    padding-top: var(--s-4);
  }

  .example-list {
    display: grid;
    gap: var(--s-2);
  }

  .example {
    border: 1px solid var(--line);
    border-radius: var(--r-sm);
    padding: var(--s-3);
    background: var(--bg);
  }

  .example__text {
    color: var(--ink);
    font-size: var(--t-sm);
    line-height: 1.45;
    margin-bottom: var(--s-2);
    white-space: pre-wrap;
  }

  .example__meta {
    color: var(--ink-4);
    font-family: var(--font-mono);
    font-size: 10px;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
  }

  .example__tag {
    display: inline-flex;
    align-items: center;
  }

  .row {
    padding: 9px var(--s-2);
    border-radius: var(--r-sm);
    cursor: pointer;
    transition: background 0.12s;
    margin-bottom: 1px;
  }

  .row:hover {
    background: var(--bg);
  }

  .row__top {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: var(--s-2);
  }

  .row__name {
    font-size: var(--t-sm);
    font-weight: 600;
    color: var(--ink);
    line-height: 1.3;
  }

  .row__count {
    font-family: var(--font-mono);
    font-size: var(--t-xs);
    color: var(--ink-2);
    flex-shrink: 0;
  }

  .row__sentiment {
    margin-top: var(--s-2);
    display: grid;
    gap: 5px;
  }

  .row__sentiment-bar {
    height: 5px;
    display: flex;
    overflow: hidden;
    border-radius: 999px;
    background: var(--line);
  }

  .row__sentiment-pos {
    background: var(--pos);
  }

  .row__sentiment-neg {
    background: var(--neg);
  }

  .row__sentiment-text {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: var(--s-2);
    color: var(--ink-3);
    font-family: var(--font-mono);
    font-size: 10px;
    line-height: 1.2;
  }

  .row__sentiment-text span {
    white-space: nowrap;
  }

  .row__sentiment-text b {
    color: var(--ink-2);
    font-weight: 600;
  }

  .modal__footer {
    padding: var(--s-3) var(--s-5);
    background: var(--bg);
    border-top: 1px solid var(--line);
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: var(--s-3);
  }

  .modal__footer-actions {
    display: flex;
    align-items: center;
    gap: var(--s-2);
  }

  .modal__footer-info {
    font-size: var(--t-xs);
    color: var(--ink-3);
    font-family: var(--font-mono);
    text-transform: uppercase;
    letter-spacing: 0.04em;
  }

  .btn {
    padding: var(--s-2) var(--s-3);
    border-radius: var(--r-sm);
    font-size: var(--t-sm);
    font-weight: 500;
    border: 1px solid var(--line);
    background: var(--surface);
    color: var(--ink-2);
  }

  .btn:hover {
    border-color: var(--ink);
    color: var(--ink);
  }

  .btn--primary {
    background: var(--accent);
    color: var(--surface);
    border-color: var(--accent);
  }

  .btn--primary:hover {
    background: var(--accent-hover);
    border-color: var(--accent-hover);
    color: var(--surface);
  }

  .btn--ghost {
    background: transparent;
    color: var(--ink-2);
  }

  /* ============================================================
     SKELETON NOTE
     ============================================================ */
  .skeleton-note {
    margin-top: var(--s-5);
    padding: var(--s-3) var(--s-4);
    background: rgba(245, 158, 11, 0.06);
    border: 1px solid rgba(245, 158, 11, 0.2);
    border-radius: var(--r-sm);
    font-size: var(--t-sm);
    color: var(--ink-2);
    line-height: 1.55;
  }

  .skeleton-note b {
    color: #B45309;
  }

  @media (max-width: 900px) {
    .header {
      padding: var(--s-3) var(--s-4);
      align-items: flex-start;
    }
    .header__meta {
      display: none;
    }
    .main {
      padding: var(--s-4) var(--s-4) 64px;
    }
    .hm-shell {
      min-width: 1540px;
    }
    .filters {
      padding: var(--s-3) var(--s-4);
    }
    .filter-info {
      margin-left: 0;
      width: 100%;

    }
    .summary-line {
      min-width: 0;
    }
    .reading-guide__items {
      grid-template-columns: 1fr;
    }
    .hm-toolbar {
      justify-content: flex-start;
      flex-wrap: wrap;
    }
  }

  .loading {

    &:before {
      content: "";
      background: rgba(255, 255, 255, 0.5);
      backdrop-filter: blur(1px);
      width: 100%;
      display: block;
      position: absolute;
      top: 0;
      height: 100%;
      border-radius: 5px;
      left: 0;
      z-index: 10;
    }

    &:after {
      animation: changeContent .8s linear infinite;
      display: block;
      content: "⠋";
      font-size: 30px;
      color: var(--deep-blue);
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 100;
    }

  }

  @keyframes changeContent {
    10% {
      content: "⠙";
    }
    20% {
      content: "⠹";
    }
    30% {
      content: "⠸";
    }
    40% {
      content: "⠼";
    }
    50% {
      content: "⠴";
    }
    60% {
      content: "⠦";
    }
    70% {
      content: "⠧";
    }
    80% {
      content: "⠇";
    }
    90% {
      content: "⠏";
    }
  }

  .modal__cell-ai {
    margin: var(--s-3) var(--s-5) 0;
    padding: var(--s-3) var(--s-4);
    border: 1px solid #C7D2FE;
    border-left: 3px solid var(--accent);
    border-radius: var(--r-sm);
    background: #F8FAFF;
    color: var(--ink-2);
    font-size: var(--t-sm);
    line-height: 1.5;
  }

  .modal__cell-ai[hidden] {
    display: none;
  }

  .modal-cell-ai__title {
    margin: 0 0 var(--s-1);
    font-family: var(--font-ui);
    font-size: var(--t-xs);
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: var(--accent);
  }

  .modal-cell-ai__period {
    margin: 0 0 var(--s-1);
    color: var(--ink-2);
    font-size: var(--t-sm);
    display: flex;
    align-content: center;
    align-items: center;
    gap: 5px;

    .btn {
      height: 27px;
      line-height: 5px;
      padding: 5px 8px;
      margin-left: 10px;
    }

    .period {
      color: #b0341a;
    }
  }

  .modal-cell-ai__list {
    margin: 0;
    padding-left: 18px;
  }

  .modal-cell-ai__list li + li {
    margin-top: var(--s-1);
  }

  .modal__col-title {
    font-size: var(--t-xs);
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: var(--ink-3);
    font-weight: 600;
    margin: 0 0 var(--s-1);
  }

  .row__bar {
    margin-top: var(--s-2);
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: center;
    gap: var(--s-2);
  }

  .row__bar-track {
    height: 9px;
    border-radius: 999px;
    background: var(--bg);
    overflow: hidden;
    border: 1px solid var(--line);
  }

  .row__bar-fill {
    height: 100%;
    min-width: 3px;
    border-radius: 999px;
    background: var(--hm-active-color);
  }

  .row__bar-label {
    min-width: 58px;
    text-align: right;
    color: var(--ink-2);
    font-family: var(--font-mono);
    font-size: 10px;
    white-space: nowrap;
  }

}
/* Спиннер */
.spinner {
  display: inline-block;
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
  vertical-align: -2px;
  margin-right: 4px;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* Состояние загрузки кнопки */
.btn.loaded {
  cursor: wait;
  opacity: 0.85;
  pointer-events: none;
  position: relative;
}

/* Пульсирующий эффект (опционально) */
.btn.loaded {
  animation: pulse 1.5s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% { box-shadow: 0 0 0 0 rgba(25, 135, 84, 0.4); }
  50%      { box-shadow: 0 0 0 6px rgba(25, 135, 84, 0); }
}



</style>
